<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.8408 23.4142L12.1337 16.7071C11.9462 16.5196 11.8408 16.2652 11.8408 16C11.8408 15.7348 11.9462 15.4805 12.1337 15.2929L18.8408 8.58582L20.255 10L14.255 16L20.255 22L18.8408 23.4142Z"
        />
    </svg>
</template>
